import React from "react";
import { TABS } from "../index";
import { AddressPopupPropTypes } from "../types";
import PropTypes from "prop-types";

const OrderTypeTabs = ({ labels, setTab, tab }) => {
    const tabStyles = (tabForOrder) =>
        `address-popup__tab ${tabForOrder === tab ? "active" : ""}`;

    return (
        <div className="address-popup__tabs">
            <button
                className={tabStyles(TABS.SINGLE_ORDER)}
                onClick={() => setTab(TABS.SINGLE_ORDER)}
            >
                {labels.singleOrder}
            </button>
            <button
                className={tabStyles(TABS.GROUP_ORDER)}
                onClick={() => setTab(TABS.GROUP_ORDER)}
            >
                {labels.groupOrder}
            </button>
        </div>
    );
};
OrderTypeTabs.propTypes = {
    labels: AddressPopupPropTypes.labels,
    setTab: PropTypes.func,
    tab: PropTypes.string,
};
export default OrderTypeTabs;
